import { formatMoney, getMoneySymbolByCurrency, Income } from '@nemuru-eng/js-api-client';

import { NetIncomeTypeOptions } from '@/components/modules/DeclaredIncome/constants/NetIncomeTypeOptions';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { NumberFormField } from '@/components/shared/components/NewContextForms/NumberFormField';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

interface NetIncomeDetailsFormProps extends FormGridOptions {
  income: Income;
}

export const NetIncomeDetailsForm = ({ income, fullWidth, fieldVariant }: NetIncomeDetailsFormProps) => {
  const isEditable = fieldVariant === FieldVariant.form;

  return (
    <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
      <NumberFormField
        label={'ANNUAL_NET_INCOME'}
        name={'annualNetIncome'}
        valueUnit={isEditable ? getMoneySymbolByCurrency(income.netIncome.annualNetIncome.currency) : ''}
        value={
          income.netIncome.annualNetIncome.amount &&
          formatMoney(amountToValueMoneyMapper(income.netIncome.annualNetIncome))
        }
      />
      <NumberFormField
        label={'MONTHLY_NET_INCOME'}
        name={'monthlyNetIncome'}
        valueUnit={isEditable ? getMoneySymbolByCurrency(income.netIncome.monthlyNetIncome.currency) : ''}
        value={
          income.netIncome.monthlyNetIncome.amount &&
          formatMoney(amountToValueMoneyMapper(income.netIncome.monthlyNetIncome))
        }
      />
      <SelectFormField
        label={'INCOME_TYPE'}
        value={income.netIncome.netIncomeType}
        name={'netIncomeType'}
        selectOptions={NetIncomeTypeOptions}
      />
    </FormGridContainer>
  );
};
